export const APP_ROUTES = {
  root: '/',
  meetings: '/meetings',
  video: '/video',
  meetingDetail: '/meetings/:meetingId',
  calendar: '/calendar',
  messenger: '/messenger',
  messengerRoom: '/messenger/:roomId',
  networkError: '/network-error',
  notFound: '/404',
  unsupportedBrowser: '/unsupported-browser',
  authRoot: '/auth',
  authWildcard: '/auth/*',
  workspace: '/workspace/:token',
  meeting: '/meeting/:inviteToken',
  invite: '/invite/:token',
  diagnosticsTest: '/test',
} as const;

export const ROOM_ROUTE_PATTERNS = [
  '/:inviteToken',
  '/meeting/:inviteToken',
  '/rooms/:roomId',
  '/widget/video/:roomId',
];
